import ArtworkRoutes from './routes'

import '@domain-group/artwork-builder/dist/styles.css'

const ArtworkBuilder = () => (
  <ArtworkRoutes />
)

export default ArtworkBuilder
